import { Chip, SxProps, Theme } from '@mui/material';
import type { SurveyStatus } from '../../../shared/services/survey/survey.model';

export const SURVEY_STATUS_LABELS: Record<SurveyStatus, string> = {
  DRAFT: 'Draft',
  ACTIVE: 'Active',
  ARCHIVED: 'Archived',
};

const statusSx = (status: SurveyStatus): SxProps<Theme> => ({
  width: 128,
  ...(status === 'DRAFT'
    ? {
      borderColor: '#9e9e9e',
      color: '#757575',
    }
    : status === 'ARCHIVED'
      ? {
        borderColor: 'text.primary',
        color: 'text.primary',
      }
      : undefined),
});

type Props = {
  status: SurveyStatus;
  sx?: SxProps<Theme>;
};

export const SurveyStatusChip = ({ status, sx }: Props) => (
  <Chip
    label={SURVEY_STATUS_LABELS[status]}
    size='small'
    color='primary'
    variant='outlined'
    sx={{ ...statusSx(status), ...sx } as SxProps<Theme>}
  />
);
